module.exports = __webpack_public_path__ + "public/files/img/chrome.f4853251.png";